import { withTheme, SvyInput as Input } from '@innovorder/savory';
import { withForm } from '@/core/form/withForm';

export const SvyInput = withTheme(Input);
export const SvyFormInput = withForm(SvyInput);
